'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiEye = function TiEye(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.4 20.7c-0.2-0.2-3.5-4.9-8-8.1-2.4-1.7-5.4-2.6-8.4-2.6-3 0-6 0.9-8.4 2.6-4.5 3.2-7.8 7.9-8 8.1-0.4 0.6-0.4 1.3 0 1.9 0.2 0.2 3.5 4.9 8 8.1 2.4 1.7 5.4 2.6 8.4 2.6 3 0 6-0.9 8.4-2.6 4.5-3.2 7.8-7.9 8-8.1 0.4-0.6 0.4-1.3 0-1.9z m-16.4 6.8c-3.2 0-5.8-2.6-5.8-5.8 0-3.3 2.6-5.9 5.8-5.9 3.2 0 5.8 2.6 5.8 5.9 0 3.2-2.6 5.8-5.8 5.8z m3.3-5.8c0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3 0-1.9 1.5-3.4 3.3-3.4 1.8 0 3.3 1.5 3.3 3.4z' })
        )
    );
};

exports.default = TiEye;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/eye.js
// module id = 3623
// module chunks = 0